import { useState } from "react";
import { motion } from "framer-motion";
import { API } from "../adminApi";
import { LOGO_URL } from "@/data";

/* খুব সরল প্রবেশ-দ্বার — মোবাইল/ইমেল + পাসওয়ার্ড, বা ওটিপি-চেহারা (প্রোটোটাইপ) */
export default function LoginScreen({ onOk }) {
  const [mode, setMode] = useState("password"); // password | otp
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [code, setCode] = useState("");
  const [codeSent, setCodeSent] = useState(false);
  const [err, setErr] = useState("");
  const [info, setInfo] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const res = await fetch(`${API}/creator/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: id, password: pw }),
      });
      const d = await res.json();
      if (!res.ok) throw new Error(d.detail || "লগইন হয়নি");
      localStorage.setItem("rom_creator_token", d.token);
      onOk();
    } catch (e2) {
      setErr(e2.message);
    }
    setBusy(false);
  };

  const inputCls =
    "mt-1 w-full rounded-xl border border-gold/20 bg-dusk/60 px-4 py-3 text-sm text-sand outline-none transition-colors focus:border-gold/60";

  return (
    <div className="flex min-h-screen items-center justify-center px-5" data-testid="creator-login">
      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-sm rounded-2xl border border-gold/25 bg-plaster/90 p-8 shadow-2xl backdrop-blur-xl"
      >
        <img src={LOGO_URL} alt="রং ও মাটি" className="mx-auto h-12 w-auto object-contain" />
        <h1 className="mt-5 text-center font-display text-3xl text-alpana">আপনার RONG-O-MATI</h1>
        <p className="mt-2 text-center text-sm text-sand/65">আপনার দোকান বা মঞ্চ পরিচালনা করুন।</p>

        <div className="mt-6 flex justify-center gap-2">
          <button
            type="button"
            data-testid="creator-login-mode-password"
            onClick={() => setMode("password")}
            className={`rounded-full px-4 py-1.5 text-xs transition-colors ${mode === "password" ? "bg-gold text-dusk" : "border border-sand/25 text-sand/60"}`}
          >
            পাসওয়ার্ড
          </button>
          <button
            type="button"
            data-testid="creator-login-mode-otp"
            onClick={() => setMode("otp")}
            className={`rounded-full px-4 py-1.5 text-xs transition-colors ${mode === "otp" ? "bg-gold text-dusk" : "border border-sand/25 text-sand/60"}`}
          >
            ওটিপি
          </button>
        </div>

        {mode === "password" ? (
          <>
            <label className="mt-6 block">
              <span className="text-xs text-sand/60">মোবাইল / ইমেল</span>
              <input
                type="text"
                value={id}
                onChange={(e) => setId(e.target.value)}
                placeholder="guru@rongomati.in"
                data-testid="creator-login-email"
                className={inputCls}
              />
            </label>
            <label className="mt-4 block">
              <span className="text-xs text-sand/60">পাসওয়ার্ড</span>
              <input
                type="password"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                data-testid="creator-login-password"
                className={inputCls}
              />
            </label>
            {err && <p data-testid="creator-login-error" className="mt-3 text-sm text-red-300">{err}</p>}
            <button
              type="submit"
              disabled={busy}
              data-testid="creator-login-submit"
              className="mt-6 w-full rounded-full bg-gold py-3 text-base font-medium text-dusk transition-transform hover:scale-[1.02] disabled:opacity-50"
            >
              {busy ? "ঢুকছি…" : "নিজের ঘরে ঢুন"}
            </button>
            <button
              type="button"
              data-testid="creator-login-forgot"
              onClick={() => setInfo("প্রোটোটাইপে পাসওয়ার্ধ-রিসেট নেই — গ্রাম-কেন্দ্র থেকে খবর করুন, আমরা বসিয়ে দেব।")}
              className="mt-4 w-full text-center text-xs text-sand/50 underline-offset-2 hover:text-gold hover:underline"
            >
              পাসওয়ার্ড ভুলে গেছেন?
            </button>
            {info && <p className="mt-2 rounded-xl border border-gold/20 bg-earthen/60 p-3 text-center text-xs leading-relaxed text-sand/70">{info}</p>}
          </>
        ) : (
          <div className="mt-6">
            <label className="block">
              <span className="text-xs text-sand/60">মোবাইল নম্বর</span>
              <input
                type="tel"
                value={id}
                onChange={(e) => setId(e.target.value)}
                placeholder="98XXXXXXXX"
                data-testid="creator-login-otp-phone"
                className={inputCls}
              />
            </label>
            {codeSent && (
              <label className="mt-4 block">
                <span className="text-xs text-sand/60">৬-অঙ্কের কোড</span>
                <input
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  inputMode="numeric"
                  maxLength={6}
                  data-testid="creator-login-otp-code"
                  className={inputCls}
                />
              </label>
            )}
            <button
              type="button"
              data-testid="creator-login-otp-send"
              onClick={() => { setCodeSent(true); setInfo("প্রোটোটাইপে আসল SMS যায় না — পাসওয়ার্ড-পথে ঢুন, ওটিপি শীঘ্রই আসছে।"); }}
              className="mt-5 w-full rounded-full border border-gold/40 py-3 text-sm text-gold transition-colors hover:bg-gold hover:text-dusk"
            >
              {codeSent ? "আবার কোড পাঠান" : "কোড পাঠান"}
            </button>
            {info && <p className="mt-3 rounded-xl border border-gold/20 bg-earthen/60 p-3 text-xs leading-relaxed text-sand/70">{info}</p>}
            <button type="button" onClick={() => setMode("password")} className="mt-4 w-full text-center text-xs text-sand/50 hover:text-gold">
              ← পাসওয়ার্ড দিয়ে ঢুন
            </button>
          </div>
        )}
      </motion.form>
    </div>
  );
}
